export function GridPinnedRows(_) {
  return null;
}